export default "__VITE_ASSET__xs43tnZL__"